import { Component } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-auth',
    template: '',
    styles: [''],
    standalone: false
})
export class AuthComponent {

  constructor(
    private authenticationService: AuthenticationService,
    private authorizationService: AuthorizationService,
    private router: Router) { }

  ngOnInit(): void {
    this.authenticationService.ensureSession().subscribe(isAuthenticated => {
      if (isAuthenticated) {
        if (this.authorizationService.isAdmin()) {
          this.router.navigate(['/admin']);
        } else {
          this.router.navigate(['/user']);
        }
      } else {
        this.router.navigate(['/login']);
      }
    });
  }
}
